import { Text } from "@chakra-ui/react";
import { Key } from "react";

import { IText } from "../../../../../utils/types";
import BlueDotIcon from "./BlueDotIcon";
import BlueLineIcon from "./BlueLineIcon";
import PurpleDotIcon from "./PurpleDotIcon";
import SkyblueRectangleIcon from "./SkyblueRectangleIcon";

export const PURPLE_DOT = "[[PURPLE_DOT]]";
export const BLUE_DOT = "[[BLUE_DOT]]";
export const SKYBLUE_RECTANGLE = "[[SKYBLUE_RECTANGLE]]";
export const BLUE_LINE = "[[BLUE_LINE]]";

export const iconMapping = (index: Key) => ({
  [PURPLE_DOT]: <PurpleDotIcon key={index} />,
  [BLUE_DOT]: <BlueDotIcon key={index} />,
  [SKYBLUE_RECTANGLE]: <SkyblueRectangleIcon key={index} />,
  [BLUE_LINE]: <BlueLineIcon key={index} />,
});

export type IconMapping = keyof typeof iconMapping;

export function isIconType(segment: string): segment is IconMapping {
  return (
    segment === PURPLE_DOT ||
    segment === BLUE_DOT ||
    segment === SKYBLUE_RECTANGLE ||
    segment === BLUE_LINE
  );
}

export function splitAndMapContent(content: string): (IconMapping | string)[] {
  return content
    .split(
      /(\[\[PURPLE_DOT\]\]|\[\[BLUE_DOT\]\]|\[\[SKYBLUE_RECTANGLE\]\]|\[\[BLUE_LINE\]\])/
    )
    .map((segment: IconMapping | string, idx) => {
      if (isIconType(segment)) {
        return iconMapping(idx)[`${segment}`];
      }
      return segment;
    });
}

interface TextContentProps {
  field: IText;
}

export default function TextContent({ field }: TextContentProps) {
  if (field.icon) {
    return <Text {...field.styles}>{splitAndMapContent(field.content)}</Text>;
  }

  return (
    <Text color="gray.600" {...field.styles}>
      {field.content}
    </Text>
  );
}
